import { useFlowHealthDrilldownConfig } from '@/pages/reports/non-ats-reports/flow-health/candidate-touchpoint/component/table/useFlowHealthDrilldownConfig';
import {
  applySearch as applySearchContacts,
  resetDrillDown as resetDrillContact,
} from '@/store/atsReports/contacts';
import { fetchContactDrilldown } from '@/store/atsReports/contacts/actions';
import {
  applySearch as applySearchHire,
  resetDrillDown as resetDrillHire,
} from '@/store/atsReports/hire';
import { fetchHireDrilldown } from '@/store/atsReports/hire/actions';
import {
  applySearch as applySearchInterview,
  resetDrillDown as resetDrillInterview,
} from '@/store/atsReports/interviews';
import { fetchInterviewDrilldown } from '@/store/atsReports/interviews/actions';
import {
  applySearch as applySearchJobs,
  resetDrillDown as resetDrillJob,
} from '@/store/atsReports/jobs';
import { fetchJobDrilldown } from '@/store/atsReports/jobs/actions';
import {
  applySearch as applySearchOffer,
  resetDrillDown as resetDrillOffer,
} from '@/store/atsReports/offers';
import { fetchOfferDrilldown } from '@/store/atsReports/offers/actions';
import {
  applySearch as applySearchPipeline,
  resetDrillDown as resetDrillPipeline,
} from '@/store/atsReports/pipeline';
import {
  applySearch as applySearchLiveJobPipeline,
  resetDrillDown as resetDrillLiveJobPipeline,
} from '@/store/atsReports/liveJobPipeline';
import { fetchPipelineDrilldown } from '@/store/atsReports/pipeline/actions';
import { fetchLiveJobPipelineDrilldown } from '@/store/atsReports/liveJobPipeline/actions';
import {
  applySearch as applySearchRejection,
  resetDrillDown as resetDrillRejection,
} from '@/store/atsReports/rejections';
import { fetchRejectionDrilldown } from '@/store/atsReports/rejections/actions';
import {
  applySearch as applySearchFlowHealth,
  clearDrilldownData as resetDrillFlowHealth,
} from '@/store/reports/flow-health/candidate-touchpoint';
import {
  applySearch as applySearchPerformance,
  resetDrillDown as resetDrillPerformance,
} from '@/store/atsReports/performance';
import { fetchCandidateTouchpointDrilldown } from '@/store/reports/flow-health/candidate-touchpoint/actions';
import {
  applySearch as applySearchUserActivity,
  clearDrilldownData as resetDrillUserActivity,
} from '@/store/reports/flow-health/user-activity';
import { fetchDrilldown } from '@/store/reports/flow-health/user-activity/actions';
import { useContactDrilldownConfig } from './drilldown-table-configs/configs/useContactDrilldownConfig';
import { useHireDrilldownConfig } from './drilldown-table-configs/configs/useHireDrilldownConfig';
import { useInterviewDrilldownConfig } from './drilldown-table-configs/configs/useInterviewDrilldownConfig';
import { useJobDrilldownConfig } from './drilldown-table-configs/configs/useJobDrilldownConfig';
import { useLiveJobPipelineDrilldownConfig } from './drilldown-table-configs/configs/useLiveJobPipelineDrilldownConfig';
import { useOfferDrilldownConfig } from './drilldown-table-configs/configs/useOfferDrilldownConfig';
import { usePipelineDrilldownConfig } from './drilldown-table-configs/configs/usePipelineDrilldownConfig';
import { useRejectionDrilldownConfig } from './drilldown-table-configs/configs/useRejectionDrilldownConfig';
import { fetchPerformanceDrilldown } from '@/store/atsReports/performance/actions';
import { usePerformanceDrilldownConfig } from './drilldown-table-configs/configs/usePerformanceDrilldownConfig';
import { fetchRequisitionsDrilldown } from '@/store/atsReports/requisitions/actions';
import {
  applySearch as applySearchRequisitions,
  resetDrillDown as resetDrillRequisitions,
} from '@/store/atsReports/requisitions';
import { useRequisitionsDrilldownConfig } from './drilldown-table-configs/configs/useRequisitionsDrilldownConfig';
import { fetchSurveyDrilldown } from '@/store/atsReports/survey/actions';
import {
  applySearch as applySearchSurvey,
  resetDrillDown as resetDrillSurvey,
} from '@/store/atsReports/survey';
import { useSurveyDrilldownConfig } from './drilldown-table-configs/configs/useSurveyDrilldownConfig';

export const OfferMetricMapping = {
  'Offers created': 'created',
  'Time to offer': 'time_to_offer',
  'Avg. revisions per offer': 'created',
  'Offers accepted': 'accepted',
  Offers: 'created',
  'Offer trend': 'created',
  'Offer acceptance rate': 'accepted',
  'Offers rejected': 'rejected',
  'Offers by department': 'created',
  'Offers by location': 'created',
  'Time to close offer': 'time_to_close_offer',
};

export const interviewMetricMapping = {
  'Completed interviews': 'interviews_completed',
  'Completed interviews trend': 'interviews_completed',
  'Completed interviews by feedback': 'interviews_completed',
  'Completed interviews by duration': 'interviews_completed',
  'Interviewed applicants': 'applicants_interviewed',
  'Avg. time spent interviewing': 'interview_duration',
  'Avg. time to fill scorecard': 'time_to_fill_scorecard',
  'Number of completed interviews': 'interviews_completed',
  'Total interviews': 'interviews_completed',
  'Canceled interviews': 'interviews_cancelled',
  'Applicants interviewed': 'applicants_interviewed',
  NO: 'no',
  YES: 'yes',
  'STRONG NO': 'strong_no',
  'STRONG YES': 'strong_yes',
  'Total scorecards': 'total_scorecards',
  'Pending scorecards': 'pending_scorecards',
};

export const pipelineMetricMapping = {
  Interviewed: 'interviewed',
  'Application review': 'applied',
  Pipeline: 'applied',
  Applied: 'applied',
  Interviews: 'interviewed',
  'Received a job offer': 'offer',
  Offer: 'offer',
  Hired: 'hired',
  'Application review stages': 'applied',
  'Interview stages': 'interviewed',
  'Offer stages': 'offer',
  'Hired stages': 'hired',
};

/** Live job pipeline drilldown: accessor/stage title -> API metric value */
export const liveJobPipelineMetricMapping = {
  prospect_total_count: 'prospect',
  application_review_total_count: 'application_review',
  interviews_total_count: 'interviews',
  offer_total_count: 'offer',
  hired_total_count: 'hired',
  prospect_actual_count: 'prospect',
  offer_actual_count: 'offer',
  hired_actual_count: 'hired',
  application_review_actual_count: 'application_review',
  interviews_actual_count: 'interviews',
  'Prospect stages': 'prospect',
  'Application review stages': 'application_review',
  'Interview stages': 'interviews',
  'Offer stages': 'offer',
  'Hired stages': 'hired',
  Prospect: 'prospect',
  'Application review': 'application_review',
  Interview: 'interviews',
  Offer: 'offer',
  Hired: 'hired',
  'Currently in prospect stages': 'prospect',
  'Currently in application review stages': 'application_review',
  'Currently in interview stages': 'interviews',
  'Currently in offer stages': 'offer',
  'Currently in hired stages': 'hired',
};

export const hireMetricMapping = {
  Hires: 'hires',
  'Time to hire': 'time_to_hire',
  'Application hired': 'hires',
  'Hires by department': 'hires',
  'Hires by source': 'hires',
  'Hire trend': 'hires',
  'Hire by source (on application)': 'hires',
};

export const contactMetricMapping = {
  'New candidates': 'contacts_created',
  Inbound: 'inbound',
  Sourced: 'sourced',
  Referral: 'referral',
  Candidates: 'contacts_created',
  'New candidate trend by source': 'contacts_created',
  'New candidate trend by source (on candidate)': 'contacts_created',
};

// The contacts report is surfaced to users as "Candidates", but the backend
// drilldown contract still expects the original contacts-based metric names.
// Map the displayed (renamed) metric name back to the backend name when building
// the request payload — the UI reads "Candidates" while the payload stays on the
// "Contacts" contract. Unmapped names (other report types) pass through unchanged.
export const candidatesToContactsMetricName: Record<string, string> = {
  'New candidates': 'New contacts',
  Candidates: 'Contacts',
  'New candidate trend by source': 'New contact trend by source',
  'New candidate trend by source (on candidate)':
    'New contact trend by source (on contact)',
};

export const jobMetricMapping = {
  'Jobs opened': 'opened_jobs',
  'Jobs closed': 'closed_jobs',
  'Jobs closed without hires': 'closed_jobs',
  'Time to close': 'time_to_close',
  'Target date breached jobs': 'target_breached_jobs',
  'Job open trend': 'opened_jobs',
  'Jobs opened by location': 'opened_jobs',
  'Jobs opened by department': 'opened_jobs',
};
export const RejectionMetricMapping = {
  'Rejected candidates': 'rejections',
  'Rejected trend': 'rejections',
  'Time to reject': 'time_to_reject',
  'Applicants rejected': 'rejections',
  Others: 'rejections',
  'No rejection reason': 'rejections',
  'We rejected them': 'rejections',
  'They rejected us': 'rejections',
  'Rejection by stage': 'rejections',
  'Rejections by source': 'rejections',
  'Rejections by source (on application)': 'rejections',
  Rejections: 'rejections',
};
export const flowHealthMetricMapping = {
  Sent: 'contacted',
  Opened: 'opened',
  replied: 'replied',
  interested: 'interested',
  Added: 'added',
  'First Message': 'sent_first',
  'Follow-up': 'sent_followup',
  Replied: 'replied',
  Interested: 'interested',
};

export const performanceMetricMapping = {
  'Sourced applications': 'sourced_candidates',
  'Screened applications': 'screened_candidates',
  'Interviews scheduled': 'interviews_scheduled',
  'Interview reschedules': 'interviews_rescheduled',
  'Interviews conducted': 'interviews_conducted',
  'Interviews canceled': 'interviews_cancelled',
  'Offers sent': 'offers_sent',
  'Offer revisions done': 'offer_revisions_done',
  Hired: 'hired_candidates',
  Rejected: 'rejected_candidates',
  'Avg. time to offer': 'time_to_offer',
  'Offer acceptance rate': 'offers_accepted',
  'Avg. time to hire': 'time_to_hire',
  'Time to hire': 'time_to_hire',
  Rejections: 'rejected_candidates',
};

export const requisitionMetricMapping = {
  'Requisitions opened': 'requisitions_opened',
  'Requisitions filled': 'requisitions_filled',
  'Requisitions closed': 'requisitions_closed',
  'Time to fill': 'time_to_fill',
  'Trend of requisitions opened': 'requisitions_opened',
  'Percentage of requisitions filled by department': 'requisitions_filled',
  'Requisitions by department': 'requisitions_opened',
  'Requisitions by requisition type': 'requisitions_opened',
  'Avg. time to fill': 'time_to_fill',
};

export const surveyMetricMapping = {
  'Candidate NPS': 'candidate_nps',
  'HM NPS': 'hm_nps',
  'Candidate NPS over time': 'candidate_nps',
  'HM NPS over time': 'hm_nps',
  'Candidate Promoters (9-10)': 'candidate_promoters',
  'Candidate Passives (7-8)': 'candidate_passives',
  'Candidate Detractors (0-6)': 'candidate_detractors',
  'HM Promoters (9-10)': 'hm_promoters',
  'HM Passives (7-8)': 'hm_passives',
  'HM Detractors (0-6)': 'hm_detractors',
};

export const customReportDrilldownConfig = {
  metric: {
    pipeline: pipelineMetricMapping,
    live_job_pipeline: liveJobPipelineMetricMapping,
    interviews: interviewMetricMapping,
    offers: OfferMetricMapping,
    hires: hireMetricMapping,
    rejections: RejectionMetricMapping,
    contacts: contactMetricMapping,
    jobs: jobMetricMapping,
    flow_candidate_touchpoint_chart: flowHealthMetricMapping,
    flow_user_activity_chart: flowHealthMetricMapping,
    recruiter_performance: performanceMetricMapping,
    requisitions: requisitionMetricMapping,
    ats_survey: surveyMetricMapping,
  },
  apiFetch: {
    pipeline: fetchPipelineDrilldown,
    live_job_pipeline: fetchLiveJobPipelineDrilldown,
    interviews: fetchInterviewDrilldown,
    offers: fetchOfferDrilldown,
    hires: fetchHireDrilldown,
    rejections: fetchRejectionDrilldown,
    contacts: fetchContactDrilldown,
    jobs: fetchJobDrilldown,
    flow_candidate_touchpoint_chart: fetchCandidateTouchpointDrilldown,
    flow_user_activity_chart: fetchDrilldown,
    recruiter_performance: fetchPerformanceDrilldown,
    requisitions: fetchRequisitionsDrilldown,
    ats_survey: fetchSurveyDrilldown,
  },
  drilldownTableConfig: {
    pipeline: usePipelineDrilldownConfig,
    live_job_pipeline: useLiveJobPipelineDrilldownConfig,
    interviews: useInterviewDrilldownConfig,
    offers: useOfferDrilldownConfig,
    hires: useHireDrilldownConfig,
    rejections: useRejectionDrilldownConfig,
    contacts: useContactDrilldownConfig,
    jobs: useJobDrilldownConfig,
    flow_candidate_touchpoint_chart: useFlowHealthDrilldownConfig,
    flow_user_activity_chart: useFlowHealthDrilldownConfig,
    recruiter_performance: usePerformanceDrilldownConfig,
    requisitions: useRequisitionsDrilldownConfig,
    ats_survey: useSurveyDrilldownConfig,
  },

  reduxStore: {
    pipeline: 'pipelineReports',
    live_job_pipeline: 'liveJobPipelineReports',
    interviews: 'interviewReports',
    offers: 'offersReports',
    hires: 'hireReports',
    rejections: 'rejectionsReports',
    contacts: 'contactsReports',
    jobs: 'jobsReports',
    flow_candidate_touchpoint_chart: 'candidateTouchpointReport',
    flow_user_activity_chart: 'userActivityReport',
    recruiter_performance: 'performanceReports',
    requisitions: 'requisitionsReports',
    ats_survey: 'surveyReports',
  },

  columnAccessor: {
    interviews: 'interview_name',
    offers: 'candidate_name',
    hires: 'candidate_name',
    rejections: 'candidate_name',
    contacts: 'candidate_name',
    jobs: 'job_name',
    pipeline: 'candidate_name',
    live_job_pipeline: 'candidate_name',
    flow_candidate_touchpoint_chart: 'candidate_name',
    flow_user_activity_chart: 'candidate_name',
    recruiter_performance: 'candidate_name',
    requisitions: 'requisition_code',
    ats_survey: 'candidate_name',
  },

  applySearch: {
    interviews: applySearchInterview,
    offers: applySearchOffer,
    hires: applySearchHire,
    rejections: applySearchRejection,
    contacts: applySearchContacts,
    jobs: applySearchJobs,
    pipeline: applySearchPipeline,
    live_job_pipeline: applySearchLiveJobPipeline,
    flow_candidate_touchpoint_chart: applySearchFlowHealth,
    flow_user_activity_chart: applySearchUserActivity,
    recruiter_performance: applySearchPerformance,
    requisitions: applySearchRequisitions,
    ats_survey: applySearchSurvey,
  },

  resetDrill: {
    interviews: resetDrillInterview,
    offers: resetDrillOffer,
    hires: resetDrillHire,
    rejections: resetDrillRejection,
    contacts: resetDrillContact,
    jobs: resetDrillJob,
    pipeline: resetDrillPipeline,
    live_job_pipeline: resetDrillLiveJobPipeline,
    flow_candidate_touchpoint_chart: resetDrillFlowHealth,
    flow_user_activity_chart: resetDrillUserActivity,
    recruiter_performance: resetDrillPerformance,
    requisitions: resetDrillRequisitions,
    ats_survey: resetDrillSurvey,
  },
};
export const DrilldownMetricMappingHeader = {
  Sent: 'contacted',
  Opened: 'opened',
  Replied: 'replied',
  Interested: 'interested',
  Added: 'added',
  'First message': 'sent_first',
  'Follow up': 'sent_followup',
};
